import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "section" }
const _hoisted_4 = { class: "columns justify-center my-rem2 !gap-4" }
const _hoisted_5 = { class: "polaroid-frame !max-w-md mb-6" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "image-subtitle" }
const _hoisted_8 = { class: "polaroid-frame !max-w-md mb-6" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "image-subtitle" }
const _hoisted_11 = { class: "section columns" }
const _hoisted_12 = { class: "ul-box !m-0" }
const _hoisted_13 = { class: "ul-box !m-0" }
const _hoisted_14 = { class: "lg:text-center" }

import ArticleModalContent from '@/components/ArticleModalContent.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'InjekcijskaTehnika',
  emits: ["close", "navigate"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_a_circular_image = _resolveComponent("a-circular-image")!
  const _component_a_info_panel = _resolveComponent("a-info-panel")!

  return (_openBlock(), _createBlock(ArticleModalContent, {
    title: _ctx.$t('articles.injekcijskaTehnika.title'),
    cover: require('@/assets/covers/kompoziti.jpg'),
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/injekcijska1.jpg')
        }, null, 8, ["image"]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.injekcijskaTehnika.introP1')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.injekcijskaTehnika.introP2')), 1),
        _createVNode(_component_a_info_panel, {
          icon: require('@/assets/png-icons/bulb.png'),
          class: "mb-rem2"
        }, {
          default: _withCtx(() => [
            _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.injekcijskaTehnika.infoBold')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.injekcijskaTehnika.infoBody')), 1)
          ]),
          _: 1
        }, 8, ["icon"])
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.injekcijskaTehnika.potekTitle')), 1),
        _createElementVNode("p", null, [
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.injekcijskaTehnika.introP3')), 1)
        ]),
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('articles.injekcijskaTehnika.obisk1Title')), 1),
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/injekcijska2.jpg')
        }, null, 8, ["image"]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.injekcijskaTehnika.obisk1P')), 1),
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('articles.injekcijskaTehnika.obisk2Title')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.injekcijskaTehnika.obisk2P1')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.injekcijskaTehnika.obisk2P2')), 1),
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('articles.injekcijskaTehnika.obisk3Title')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.injekcijskaTehnika.obisk3P')), 1)
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.injekcijskaTehnika.clinicalTitle')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.injekcijskaTehnika.clinicalP')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: require('@/assets/injekcijska-before.jpg'),
              loading: "lazy",
              alt: ""
            }, null, 8, _hoisted_6),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('articles.injekcijskaTehnika.beforeTherapy')), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              src: require('@/assets/injekcijska-after.jpg'),
              loading: "lazy",
              alt: ""
            }, null, 8, _hoisted_9),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('articles.injekcijskaTehnika.afterTherapy')), 1)
          ])
        ])
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('articles.injekcijskaTehnika.prednostiTitle')), 1),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('articles.injekcijskaTehnika.prednostiList'), (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: String(item)
              }, _toDisplayString(item), 1))
            }), 128))
          ])
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('articles.injekcijskaTehnika.primernaTitle')), 1),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('articles.injekcijskaTehnika.primernaList'), (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: String(item)
              }, _toDisplayString(item), 1))
            }), 128))
          ])
        ])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("p", _hoisted_14, [
        _createTextVNode(_toDisplayString(_ctx.$t('articles.injekcijskaTehnika.cenikPre')), 1),
        _createElementVNode("b", {
          class: "internal-link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navigate', 'cenik', 'injekcijska-tehnika')))
        }, _toDisplayString(_ctx.$t('articles.injekcijskaTehnika.cenikLinkText')), 1),
        _createTextVNode(_toDisplayString(_ctx.$t('articles.injekcijskaTehnika.cenikPost')), 1)
      ])
    ]),
    _: 1
  }, 8, ["title", "cover"]))
}
}

})